// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details-section {
  height: calc(100vh - 72px);
  overflow: auto;
  position: relative;
  padding-bottom: 56px; }
  .details-section .ant-pagination {
    background-color: var(--white);
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
    padding: 12px;
    position: fixed;
    width: calc(100% - 250px);
    bottom: 0;
    z-index: 1;
    display: flex;
    justify-content: flex-end; }

.chart-card {
  border: 1px solid #e1e1e1;
  padding: 24px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
  margin: 12px; }

.heat-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border-radius: 4px;
  padding: 4px;
  color: white; }
  .heat-card.good {
    background-color: rgba(255, 0, 0, 0.685); }
  .heat-card.better {
    background-color: #ffba25; }
  .heat-card.best {
    background-color: #08b608d4; }

.icon {
  height: 15px;
  width: 30px; }

.info {
  color: black; }

.bg-success {
  background-color: #08b608d4 !important; }

.bg-warning {
  background-color: #ffba25 !important; }

.bg-danger {
  background-color: rgba(255, 0, 0, 0.685) !important; }

@media all and (max-width: 768px) {
  .details-section .ant-pagination {
    width: 100%; } }
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/dashboard.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,oBAAoB,EAAA;EAJxB;IAOQ,8BAA8B;IAC9B,2CAA2C;IAC3C,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB,EAAA;;AAIjC;EACI,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY,EAAA;;AAGhB;EACI,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY,EAAA;EAPhB;IAUQ,wCAAwC,EAAA;EAVhD;IAcQ,yBAAmC,EAAA;EAd3C;IAkBQ,2BAA2B,EAAA;;AAGnC;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAmB,EAAA;;AAGvB;EACI,sCAAsC,EAAA;;AAG1C;EACI,oCAA8C,EAAA;;AAGlD;EACI,mDAAmD,EAAA;;AAGvD;EACI;IAEQ,WAAW,EAAA,EACd","sourcesContent":[".details-section {\n    height: calc(100vh - 72px);\n    overflow: auto;\n    position: relative;\n    padding-bottom: 56px;\n\n    .ant-pagination {\n        background-color: var(--white);\n        box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);\n        padding: 12px;\n        position: fixed;\n        width: calc(100% - 250px);\n        bottom: 0;\n        z-index: 1;\n        display: flex;\n        justify-content: flex-end;\n    }\n}\n\n.chart-card {\n    border: 1px solid #e1e1e1;\n    padding: 24px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);\n    margin: 12px;\n}\n\n.heat-card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100px;\n    border-radius: 4px;\n    padding: 4px;\n    color: white;\n\n    &.good {\n        background-color: rgba(255, 0, 0, 0.685);\n    }\n\n    &.better {\n        background-color: rgb(255, 186, 37);\n    }\n\n    &.best {\n        background-color: #08b608d4;\n    }\n}\n.icon {\n    height: 15px;\n    width: 30px;\n}\n\n.info {\n    color: rgb(0, 0, 0);\n}\n\n.bg-success {\n    background-color: #08b608d4 !important;\n}\n\n.bg-warning {\n    background-color: rgb(255, 186, 37) !important;\n}\n\n.bg-danger {\n    background-color: rgba(255, 0, 0, 0.685) !important;\n}\n\n@media all and (max-width: 768px) {\n    .details-section {\n        .ant-pagination {\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
